import { EWcLocation } from '../../types/filters';

interface IWcLocations {
  label: string;
  value: EWcLocation;
}

export const WC_LOCATIONS: IWcLocations[] = [
  { label: 'В доме', value: EWcLocation.Indoors },
  { label: 'На улице', value: EWcLocation.Outdoors },
];
